
import MappedCTaskHistoryNotFoundSvgComponent from '../../assets/svg-components/not-found/mappedc-task-history';
import './index.scss';

export default function MappedCheckpointMasterTaskHistoryNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/mappedc-task-history.svg"
            className="not-found-image img-fluid not-found-image-executor-task"
          /> */}
          <div className="not-found-image img-fluid not-found-image-executor-task">
            <MappedCTaskHistoryNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">There is no historical tasks available for this checkpoint that corresponds to its entity mapping.</p>
        </div>
      </div>
    </>
  );
}
